import { DialogTitle } from "@material-ui/core";
import React from "react";
import { SubmitForProductionDialogContent } from "./SubmitForProductionDialogContent";

interface ISubmitForProductionUpdateDialogContent {
  showLoading: boolean;
  preValidateError: string | null | undefined;
  submitError: string | null | undefined;
  successMessage: string | null | undefined;
  name: string;
}

export const SubmitForProductionUpdateDialogContent = (props: ISubmitForProductionUpdateDialogContent) => {
  const { showLoading, preValidateError, submitError, successMessage, name } = props;

  return (
    <>
      <DialogTitle id="alert-dialog-title">{`Submit ${name} Interface for Production Update`}</DialogTitle>
      <SubmitForProductionDialogContent
        showLoading={showLoading}
        preValidateError={preValidateError}
        submitError={submitError}
        successMessage={successMessage}
        message="This will submit a service call for your custom Interface Fields to be reviewed.
          Only the latest submitted fields will be considered.
          Please view your fields to verify that the Proposed Access is correct."
      />
    </>
  );
};
